module.exports = __webpack_public_path__ + "img/1488138571.df8b14a4.jpg";